<template>
  <div
    id="service"
    :class="$platformClass"
    :style="{ paddingTop: pagePaddingTop }"
  >
    <nav
      class="switch-types"
      :class="$platformClass"
      v-if="serviceStatus.haveTwoService"
    >
      <a
        class="switch-type"
        :class="[$platformClass, showService ? 'active' : false]"
        @click="switchType('serviceContract')"
        v-touchActive
      >
        {{ languages.termsOfUse }}
      </a>
      <a
        class="switch-type"
        :class="[$platformClass, !showService ? 'active' : false]"
        @click="switchType('userContract')"
        v-touchActive
      >
        {{ languages.privacyPolicy }}
      </a>
    </nav>
    <transition-group
      tag="article"
      class="service-content"
      :class="$platformClass"
      style="padding-top: 18px; padding-bottom: 10px; position: relative"
    >
      <iframe
        v-if="showService"
        class="service-content-iframe"
        :class="$platformClass"
        key="service"
        :src="serviceHref"
      ></iframe>
      <iframe
        v-if="!showService"
        class="service-content-iframe"
        :class="$platformClass"
        key="policy"
        :src="policyHref"
      ></iframe>
    </transition-group>
  </div>
</template>
<script>
import { SERVICE_TERM_URL, PRIVICY_TERM_URL } from '../../utiles';
import globalConfig from '../../utiles/globalConfig';
import { LOAD_SERVICE_STATUS } from '../../store/services';
import { isKrNewPolicyGame } from './Home.vue';
const SERVICE_CONTECT = 'serviceContract';
const USER_CONTECT = 'userContract';
const search = globalConfig.getLocationSearch();
export default {
  data() {
    return {
      showService: true,
      serviceHref: SERVICE_TERM_URL + search,
      policyHref: PRIVICY_TERM_URL + search,
      transitionName: 'page-left',
      isKrNewPolicyGame: isKrNewPolicyGame()
    };
  },
  computed: {
    languages() {
      return this.$store.state.passport.languages;
    },
    serviceStatus() {
      return this.$store.state.services;
    },
    pagePaddingTop() {
      return this.$store.state.services.haveTwoService
        ? this.$isOmni
          ? '105px'
          : '95px'
        : '10px';
    }
  },
  created() {
    this.$store.dispatch(LOAD_SERVICE_STATUS);
  },
  methods: {
    switchType(type) {
      switch (type) {
        case SERVICE_CONTECT:
          this.showService = true;
          // this.serviceHref = SERVICE_TERM_URL + search;
          this.transitionName = 'page-right';
          // this.serviceContent = terms;
          break;
        case USER_CONTECT:
          this.showService = false;
          // this.serviceHref = PRIVICY_TERM_URL + search;
          this.transitionName = 'page-left';
          // this.serviceContent = userAgreement;
          break;
      }
    }
  },
  watch: {
    '$route.query.type': {
      immediate: true,
      handler(newVal) {
        if (!this.isKrNewPolicyGame) {
          return;
        }
        const gameLink = {
          211: `//gpassport.${globalConfig.getMainHost()}/center/servicePrivicy/customize?keyWord=privicy_dzgkr`,
          227: `//gpassport.${globalConfig.getMainHost()}/center/ServicePrivacy/privacy`
        };
        let gameId = +globalConfig.getHrefParam('gameId');
        if (gameId && gameLink[gameId]) {
          this.policyHref = gameLink[gameId];
        }
        if (newVal === 'userContract') {
          this.switchType(USER_CONTECT);
        } else {
          this.switchType(SERVICE_CONTECT);
        }
      }
    }
  }
};
</script>

<style lang="scss">
@import '../../assets/scss/base.scss';
@import '../../assets/scss/platform-base.scss';
#service {
  position: relative;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  background-color: #f5f5f5;
  padding: 10px;
  padding-top: 95px;
}
$activeH: 65px;
.switch-types {
  position: absolute;
  top: 10px;
  width: 100%;
  height: $activeH;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}
.switch-type {
  $normalH: 50px;
  display: block;
  float: left;
  width: 345px;
  font-size: 24px;
  color: black;
  height: 100%;
  line-height: $activeH;
  text-align: center;
  background-color: #e2e2e2;
  transition: all 0.8s;
  &.active {
    background-color: white;
    color: #0596ff;
  }
}

.service-content {
  width: 100%;
  height: 100%;
  padding-top: 38px;
  padding-bottom: 60px;
  box-sizing: border-box;
  // line-height: 32px;
  // font-size: 24px;
  // color:black;
  background: white;
}

.service-content-iframe {
  height: 100%;
  width: 100%;
  -ms-overflow-style: none;
  overflow: -moz-scrollbars-none;
  &::-webkit-scrollbar {
    width: 0 !important;
  }
}

@media screen and (orientation: landscape) {
  //横屏
  .switch-type {
    width: 610px !important;
  }
  .service-content {
    margin-top: 18px;
  }
}
</style>
